import { Component, Input } from '@angular/core';
import { ProdutoPromocional } from '../../../core/models/produtos/produto-promocional';
import { ProdutoFichaTecnica } from '../../../core/models/produtos/produto-ficha-tecnica';

/**
 * Conteúdo (corpo) do `<ng-template #adicionarItensInformacoes let-modal>` do componente pai
 * (pedido-adicionar-itens-modal.component.html:224-280 na árvore atual — os limites citados no
 * brief original, linha 1592-1648, estavam defasados pelas extrações das Tasks 1-12; reancorado
 * via `grep -n "adicionarItensInformacoes"`).
 *
 * Escopo: SOMENTE o `modal-body` (226-233 do bloco original... na prática linhas 233-275 do
 * arquivo atual: produto + ficha técnica + tabela de links). `<ng-template>`, `modal-header`
 * (225-231) e `modal-footer` (277-279) permanecem intocados no pai, assim como o método abridor
 * `modalAdicionarItensInformacoes(content: any, id_produto: number)` (ts:5483).
 * `@ViewChild("adicionarItensInformacoes") adicionarItensInformacoesTemplate` (ts:292) continua
 * apontando para o próprio `<ng-template>`, que não se move — sem quebra (é, aliás, dead code:
 * grep confirma que nenhum dos seis `@ViewChild` de template deste arquivo é referenciado fora
 * da própria declaração).
 *
 * Correção de encoding: o inventário funcional original apontava `ngbTooltip="InformaÃ§Ãµes"`
 * (mojibake UTF-8/Latin-1) próximo da linha 1151 do arquivo ORIGINAL (master). Essa string vivia
 * na linha de ações mobile duplicada (`adicionar_itens_acoes_mobile`, `placement="top"`,
 * master:1150) — uma segunda cópia do ícone "Informações" espelhando a linha desktop
 * (`placement="left"`, master:1095, já corretamente acentuada). As Tasks 8-12 já consolidaram
 * ambas as linhas de ações (desktop + mobile) em um único bloco responsivo dentro de
 * `detalhe-painel/pedido-itens-detalhe-painel.component.html:246-262` (botões com texto, sem
 * `ngbTooltip`) — a duplicata com mojibake não existe mais em lugar nenhum da árvore atual
 * (`grep -rn "InformaÃ" src/` não retorna nada; `grep -rln "fa-info" .../pedido-adicionar-itens-modal/`
 * só encontra a cópia já correta em detalhe-painel:253). O corpo desta ng-template (que É o
 * escopo real desta Task 13) nunca teve a string corrompida — verificado byte a byte
 * (`xxd`: "Informações" = c3a7 c3b5, UTF-8 válido para ç/õ) nas 3 ocorrências de texto
 * acentuado deste bloco (título do modal, "Ficha Técnica", "Adicionar Itens (Informações)").
 * Nenhuma alteração de texto foi necessária além de portar o HTML verbatim.
 */
@Component({
  selector: 'app-pedido-itens-modal-informacoes',
  standalone: false,
  templateUrl: './pedido-itens-modal-informacoes.component.html',
  styleUrls: ['./pedido-itens-modal-informacoes.component.scss']
})
export class PedidoItensModalInformacoesComponent {
  /* Produto selecionado — mesma referência do pai (ts:177: `produtoInformacoesSelecionado: ProdutoPromocional = null`). */
  @Input() produtoSelecionado: ProdutoPromocional = null;

  /* Links de ficha técnica do produto (ts:172: `produtoFichasTecnicas: ProdutoFichaTecnica[] = []`). */
  @Input() fichasTecnicas: ProdutoFichaTecnica[] = [];
}
